import SmallTips from './Index.vue'

SmallTips.install = function(Vue) {
  Vue.component(SmallTips.name, SmallTips)
}

export default SmallTips
